import PropTypes from "prop-types";
import ProfileIncomeCircle from "./profileIncomeCircle";

const ProfileMainSection = ({
  userId,
  userTaskManager,
  userTasksCurrentWeek,
  userTasksCurrentMonth,
}) => {
  // Sum all incomes in userTasksLastWeek
  const incomeWeek = userTasksCurrentWeek.reduce(
    (total, task) => total + (task.income || 0),
    0
  );

  // Sum all incomes in userTasksLastMonth
  const incomeMonth = userTasksCurrentMonth.reduce(
    (total, task) => total + (task.income || 0),
    0
  );

  console.log("userId: ", userId);
  // console.log("userTaskManager: ", userTaskManager);
  // console.log("userTasksCurrentWeek: ", userTasksCurrentWeek);
  // console.log("userTasksCurrentMonth: ", userTasksCurrentMonth);

  return (
    <div className="profile-MainSection text-center p-1">
      <div className="flex justify-around items-center">
        {/* Pass different images for week, today, and month */}
        <div className="week-income">
          <ProfileIncomeCircle
            income={incomeWeek} // Use the calculated income for the week
            imageUrl="https://picsum.photos/200?random=week"
          />
          <p className="text-xs">week</p>
        </div>
        <div className="today-income">
          <ProfileIncomeCircle
            income={userTaskManager ? userTaskManager.income : "......"}
            imageUrl="https://picsum.photos/200?random=today"
          />
          <p className="text-xs">today</p>
        </div>
        <div className="month-income">
          <ProfileIncomeCircle
            income={incomeMonth} // Use the calculated income for the month
            imageUrl="https://picsum.photos/200?random=month"
          />
          <p className="text-xs">month</p>
        </div>
      </div>
    </div>
  );
};

ProfileMainSection.propTypes = {
  userId: PropTypes.string.isRequired,
  userTaskManager: PropTypes.object,
  userTasksCurrentWeek: PropTypes.array.isRequired,
  userTasksCurrentMonth: PropTypes.array.isRequired,
};

export default ProfileMainSection;
